export const layout = {
  backgroundColor: '#f5f5f5',
  padding: '95px 28px',
  height: '100%',
  minHeight: '100vh'
};
